import { useCallback, useMemo } from 'react';
import { useField } from 'react-final-form';
import { OrderFormItem } from 'models/WorkflowConfiguration';
import { getCheckedFileIds, syncCheckedFiles } from '../utils/stageFiles';

// Ticked file ids over the order field, so ticking never touches message steps.
const useCheckedFilesField = () => {
  const {
    input: { value, onChange },
  } = useField<OrderFormItem[]>('orderItems');

  const checkedFilesIds = useMemo(
    () => getCheckedFileIds(value || []),
    [value],
  );

  const setCheckedFilesIds = useCallback(
    (ids: string[]) => onChange(syncCheckedFiles(value || [], ids)),
    [onChange, value],
  );

  return { checkedFilesIds, setCheckedFilesIds };
};

export default useCheckedFilesField;
